<div [formGroup]="formGroup">
  <input type="number" [formControlName]="field.name" [id]="field.name" step="0.1" />
</div>
